"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadService = void 0;
const api_1 = require("./api");
const PATH = '/upload/api/v1';
class UploadService {
    static async uploadFile(id, payload, cancelToken, onUploadProgress) {
        try {
            const source = api_1.API.createCancelToken();
            cancelToken.cancel = source.cancel;
            return await api_1.API.post({
                url: `${PATH}/content/${id}/submit`,
                contentType: 'multipart/form-data',
                body: payload,
                onUploadProgress,
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    accept: 'application/json'
                }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getContent(key) {
        try {
            return await api_1.API.get({
                url: `${PATH}/content/${key}`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.UploadService = UploadService;
//# sourceMappingURL=upload-service.js.map